import { render, staticRenderFns } from "./ServicoDigitalTab.vue?vue&type=template&id=04031b8b&lang=true"
import script from "./ServicoDigitalTab.vue?vue&type=script&lang=js"
export * from "./ServicoDigitalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports